import BaseModel from "@/models/BaseModel";

export enum Type {
    CASE = 0,
    SUBCASE = 1,
    JOINTCASE = 2
}

export enum State {
    ALL = 0,
    INVOICE = 1,
    COLLECTION = 2,
    SURVEILLANCE = 3
}

export enum CaseState {
    CLOSED = 0,
    OPEN = 1,
    PENDINGRECALL = 2,
    RECALL = 3,
    PENDINGWAIT = 4,
    WAIT = 5
}

export default class CaseModel extends BaseModel {
    public static isJointCase(caseType: number) {
        return caseType === Type.JOINTCASE;
    }
}

export interface Warnings {
    invoiceNumber: string;
    capitalRemaining: string;
    capitalOriginal: string;
}

export interface InoutCase {
    avdNr: number;
    caseId: string;
    historik: string;
    isDeleted: number;
    kliNr: number|string;
    refNr: string;
    reggedAt: Date;
    reggedBy: string;
    reggedCwcreditorId: number;
    reggedCwcreditorName: string;
    rowId: number;
    site: string;
    userId: number;
    inoutDebtor: InoutDebtor[];
    inoutDebt: InoutDebt[];
    inoutHstAtt: InoutHstAtt[];
}

export interface InoutCaseInput {
    site: string;
    caseId: string;
    creditorNo: number | null;
    departmentNo: number | null;
    referenceNo: string;
    historyInfo: string;
    reggedBy: string;
    reggedAt: Date;
    reggedCWCreditorId: number | null;
    reggedCWCreditorName: string | null;
    inoutDebtor: InoutDebtorClass[];
    inoutDebt: InoutDebtClass[];
    inoutHstAtt: InoutHstAttClass[];
}

export interface RegisterCaseCustomer {
    id: string;
    title: string | null;
    firstName: string | null;
    lastName: string;
    companyName: string | null;
    contactPerson: string | null;
    customerType: number | null;
    customerRole: number | null;
    countryCode: string;
    address: string | null;
    province: string | null;
    postalCode: string;
    postalCode2: string | null;
    city: string;
    coAddress: string;
    primaryPhone: string;
    secondaryPhone: string;
    email: string;
    giroNo: string;
}

export interface InoutDebtorClass {
    debtorType: number | null;
    extType: number | null;
    title: string | null;
    companyName: string | null;
    firstName: string | null;
    lastName: string | null;
    debtorId: string | null;
    idNo: string | null;
    addr1: string | null;
    addr2: string | null;
    cityCode: string | null;
    cityCode2: string | null;
    city: string | null;
    email: string | null;
    phoneHome: string | null;
    phoneWork: string | null;
    phoneCell: string | null;
    province: string | null;
    countryCode: string | null;
    giroNr: string | null;
}
export interface InoutDebtor { // the reason theres a second one beisides InoutDebtorClass, is because InoutDebtorClass was created manually and not synced with db table
    adr1: string;
    adr2: string;
    caseId: string | null;
    debtorId: string | null;
    email: string;
    enamn: string;
    extTyp: number | null;
    fnamn: string;
    foretagNamn: string | null;
    giroNr: string;
    gldTyp: number;
    idNr: string;
    landskod: string;
    postNr: string;
    postNr2: string | null;
    postOrt: string;
    provins: string | null;
    rowId: string | null;
    telefax: string | null;
    telefon: string;
    teleovr: string;
    title: string | null;
}

export interface RegisterCaseDebt {
    invoiceDate: Date;
    invoiceDueDate: Date;
    invoiceNumber: string | null;
    invoiceDescription: string | null;
    invoiceDescriptionExtra: string | null;
    extraInfoNeeded: boolean;
    remainingCapital: number | null;
    remainingFee: number | null;
    interestRate: number | null;
    remainingInterest: number | null;
    originalCapital: number | null;
    ocr: string | null;
    interestCode: string | null;
    plateNumber: string | null;
    vehicleType: string | null;
    violation: string | null;
    parkTime: Date | null;
    violationAddress: string | null;
    objectNumber: string | null;
    objectAddress: string | null;
    squareMeter: string | null;
    promissoryNote: string | null;
}

export interface InoutDebtClass {
    customerNo: string | null;
    description: string | null;
    termsOfPayment: string | null;
    termsOfInterest: string | null;
    debtId: string | null;
    interestRate: string | null;
    interestFrom: string | null;
    interestCode: string | null;
    originalCapital: string | null;
    remainingCapital: string | null;
    remainingFee: string | null;
    remainingInterest: string | null;
    ocrNr: string | null;
    invoiceDate: string | null;
    dueDay: string | null;
    parkRegNr: string | null;
    parkFordonTyp: string | null;
    parkOvertradelse: string | null;
    parkKontrollTid: string | null;
    parkKontrollAdress: string | null;
    objectNo: string | null;
    objectAddress: string | null;
    objectArea: string | null;
    reversNr: string | null;
    contractDate: string | null; // date?
}

export interface InoutDebt { // the reason theres a second one beisides InoutDebtClass, is because InoutDebtClass was created manually and not synced with db table
    avser: string | null;
    caseId: string | null;
    contractDate: string | null;
    debtId: string | null;
    faktDat: string;
    fakturaTyp: string | null;
    forfDag: string;
    interestStart: string | null;
    kundNr: string | null;
    kundNr2: string | null;
    lghNr: string | null;
    objAdr: string | null;
    orgKapital: number;
    parkFordonTyp: string | null;
    parkKontrollAdress: string | null;
    parkKontrollTid: string | null;
    parkOvertradelse: string | null;
    parkRegNr: string | null;
    ranteKod: string;
    ranteSats: number | null;
    restAvgift: number | null;
    restKapital: number | null;
    restRanta: number | null;
    reversNr: string | null;
    rowId: string | null;
    storLek: string | null;
}

export interface InoutHstAttClass {
    attachmentId: string;
    fileName: string;
    fileExtension: string;
    file: string;
}

export interface InoutHstAtt { // the reason theres a second one beisides InoutHstAttClass, is because InoutHstAttClass was created manually and not synced with db table
    caseId: string;
    fileExtension: string;
    fileName: string;
    hstAttId: string;
    rowId: string;
    theFile: string;
}

export interface Query {
    caseId: string | null;
    perPage: number;
    currentPage: number;
}

interface Where {
    path: string;
    value: string;
}

interface OrderBy {
    path: string;
    descending: boolean | null;
}

export const InoutCasesQuery = (p: Query, where: Where[], orderBy: OrderBy[]) => {
    return {
        query: `query(
            $first: Int,
            $after: String,
            $where: [WhereExpressionGraph],
            $orderBy: [OrderByGraph]) {
        inoutCases(first: $first, after: $after, where: $where, orderBy: $orderBy) {
            totalCount,
                items {
                    avdNr
                    caseId
                    historik
                    isDeleted
                    kliNr
                    refNr
                    reggedAt
                    reggedBy
                    reggedCwcreditorId
                    reggedCwcreditorName
                    rowId
                    site
                    userId
                    inoutDebtor {
                        adr1
                        adr2
                        caseId
                        debtorId
                        email
                        enamn
                        extTyp
                        fnamn
                        foretagNamn
                        giroNr
                        gldTyp
                        idNr
                        landskod
                        postNr
                        postNr2
                        postOrt
                        provins
                        rowId
                        telefax
                        telefon
                        teleovr
                        title
                    }
                    inoutDebt {
                        avser
                        caseId
                        contractDate
                        debtId
                        faktDat
                        fakturaTyp
                        forfDag
                        interestStart
                        kundNr
                        kundNr2
                        lghNr
                        objAdr
                        orgKapital
                        parkFordonTyp
                        parkKontrollAdress
                        parkKontrollTid
                        parkOvertradelse
                        parkRegNr
                        ranteKod
                        ranteSats
                        restAvgift
                        restKapital
                        restRanta
                        reversNr
                        rowId
                        storLek
                    }
                    inoutHstAtt {
                        caseId
                        fileExtension
                        fileName
                        hstAttId
                        rowId
                        theFile
                    }
                }
            }
        }`,
        variables: {
            first: p.perPage,
            after: ((p.currentPage * p.perPage) - p.perPage - 1).toString(),
            where,
            orderBy
        },
    };
};